// ag-charts import removed - using ng2-charts now

export interface LocationDeviceRow {
	location: string;
	macbook: number;
	windows: number;
}

// ASSET_ALLOCATED_OPTIONS removed - chart configuration now handled by ng2-charts in component


export const MONTH_OPTIONS = [
	{ label: 'January', value: 1 },
	{ label: 'February', value: 2 },
	{ label: 'March', value: 3 },
	{ label: 'April', value: 4 },
	{ label: 'May', value: 5 },
	{ label: 'June', value: 6 },
	{ label: 'July', value: 7 },
	{ label: 'August', value: 8 },
	{ label: 'September', value: 9 },
	{ label: 'October', value: 10 },
	{ label: 'November', value: 11 },
	{ label: 'December', value: 12 },
];

export const DAMAGE_ANALYTICS_DATA: any[] = [
	{
		damageAnalytics: 'Macbook',
		count: 150,
		location: 'Bangalore',
		month: 11,
		year: 2025,
		totalCost: 75000,
	},
	{
		damageAnalytics: 'Windows',
		count: 200,
		location: 'Bangalore',
		month: 11,
		year: 2025,
		totalCost: 50000,
	},
];

export const RELEASE_TYPE_OPTIONS = [
	{ label: 'Voluntary', value: 'Voluntary' },
	{ label: 'Involuntary', value: 'Involuntary' }
];

export const REASON_OPTIONS = [
	{ label: 'Performance Issue', value: 'Performance Issue' },
	{ label: 'Compliance Issue', value: 'Compliance Issue' },
	{ label: 'Project requirement ceased', value: 'Project requirement ceased' }
];